import { FormModal as BaseFormModal, FlexSpace, InputField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { responsiveFields } from '@ubeya/shared-web/style';
import { required } from '@ubeya/shared/utils/form';
import React, { useCallback, useContext } from 'react';
import styled, { css } from 'styled-components';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const FormModal = styled(BaseFormModal)`
  ${({ $isMobileOnly }) =>
    $isMobileOnly &&
    css`
      max-height: 65vh;
    `}
`;

const CostCenterModal = ({ updateCostCenter, selectedCostCenter, onClose, addCostCenter }) => {
  const { t } = useContext(ConfigContext);

  const handleSubmit = useCallback(
    async (values) => {
      if (selectedCostCenter.id) {
        await updateCostCenter({ id: selectedCostCenter.id, ...values });
      } else {
        await addCostCenter(values);
      }
      onClose();
    },
    [addCostCenter, onClose, selectedCostCenter.id, updateCostCenter]
  );

  const initialValues = {
    name: selectedCostCenter?.name,
    identifier: selectedCostCenter?.identifier
  };

  return (
    <FormModal
      initialValues={initialValues}
      onSubmit={handleSubmit}
      size="small"
      onClose={onClose}
      title={t('addCostCenter')}
      confirmText={t('save')}
      showCancelButton
      disabledOnPristine={false}>
      <Container>
        <InputField name="name" title={t('costCenterName')} autoFocus required={required} />
        <InputField name="identifier" title={t('costCenterIdentifier')} required={required} />
      </Container>
    </FormModal>
  );
};

export default CostCenterModal;
